/* eslint-disable import/no-unresolved */
import React, {
    useState,
    useContext,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';

import { LocaleContext } from 'app/containers/LocaleProvider';

import PromoSetDishDetails from '../../../../../promo-sets/src/trial-app/components/PromoSetDishDetails';
import { ConfigContext } from '../ConfigProvider';
import { PromoCheckoutPatchedDishesContext } from '../PromoCheckoutMenuDishesAdapter';

import ModalSlider from '../ModalSlider';
import DishDetails from '../DishDetails';

import './dish-details-list.scss';


const getDishesOrder = (initialDish) => {
    if (!initialDish) {
        return [];
    }

    const el = document.querySelector(`[data-toggle-details-id="${initialDish.id}"]`);
    const siblings = el.closest('[data-toggle-details-parent]')?.querySelectorAll('[data-toggle-details-id]');
    const dishesOrder = siblings ? Array.from(siblings).map((li) => li.dataset.toggleDetailsId) : [];

    return dishesOrder;
};


export default function DishDetailsList(props) {
    const {
        dialogType,
        isEntered,
        transitionState,
        initialDishId = '',
        basketDishes,
        buttonsDisabled,
        handleCloseDetails,
    } = props;

    const { locale } = useContext(LocaleContext);

    const {
        dishCategories,
        canChangePortionsCount,
    } = useContext(ConfigContext);

    const { dishesArray } = useContext(PromoCheckoutPatchedDishesContext);
    const initialDish = useMemo(() => {
        const dish = dishesArray.find((d) => d.id === initialDishId);
        return dish;
    }, [initialDishId, dishesArray]);

    const [activeDishId, setActiveDishId] = useState(null);

    const {
        title: titleRu,
        detailsTitle: detailsTitleRu,
        titleEn,
        detailsTitleEn,
    } = initialDish ? dishCategories[initialDish.category] : { title: '', dishesOrder: [] };

    const dishesOrder = getDishesOrder(initialDish);

    const dishes = dishesOrder
        .map((dishId) => {
            const dish = dishesArray.find((d) => d.id === dishId);
            return dish;
        })
        .filter((dishData) => Boolean(dishData))
        .filter((dishData) => dishData.detailContent);

    const initialIndex = initialDish ? dishes.findIndex((dish) => dish.id === initialDish.id) : 0;

    const titles = {
        ru: detailsTitleRu || titleRu,
        en: detailsTitleEn || titleEn,
    };
    const title = titles[locale];
    const titleStr = Array.isArray(title) ? title.join(' ') : title;

    const dishesSlice = isEntered ? dishes : dishes.slice(initialIndex, initialIndex + 1);

    return (
        <ModalSlider
            onClickClose={handleCloseDetails}
            transitionState={transitionState}
            title={titleStr}
            initialIndex={initialIndex}
            onChangeSlide={(index) => {
                const dish = dishes[index];
                if (dish?.id) setActiveDishId(dish.id);
            }}
            dialogType={dialogType}
            items={dishesSlice}
        >
            {dialogType === 'OLD_MODAL' && dishesSlice.map((dish, index) => {
                const {
                    id, originalPriceWithStep, discountPriceWithStep, price, dishCountStep, isSet, isTimeHidden,
                } = dish;

                const { portion } = basketDishes.find((bd) => {
                    if (isSet) {
                        return dish.dishes.includes(bd.id);
                    }
                    return bd.id === id;
                }) || { portion: 0 };

                const portionButtonProps = {
                    buttonsDisabled,
                    id,
                    portion,
                    dishCountStep,
                    originalPriceWithStep,
                    discountPriceWithStep,
                    price,
                    isInfoBlock: false,
                };

                return (
                    <DishDetails
                        isEntered={isEntered}
                        isActive={activeDishId === dish.id}
                        dish={dish}
                        key={id}
                        index={isEntered ? index : initialIndex}
                        portionButtonProps={portionButtonProps}
                        canChangePortionsCount={canChangePortionsCount}
                    />
                );
            })}
            {dialogType === 'SMALL_MODAL' && dishesSlice.map((dish, index) => (
                <PromoSetDishDetails
                    isEntered={isEntered}
                    dish={dish}
                    key={dish.id}
                    index={isEntered ? index : initialIndex}
                />
            ))}
        </ModalSlider>
    );
}


DishDetailsList.propTypes = {
    isEntered: PropTypes.bool.isRequired,
    transitionState: PropTypes.string.isRequired,
    initialDishId: PropTypes.string,
    basketDishes: PropTypes.arrayOf(
        PropTypes.shape({}),
    ).isRequired,
    buttonsDisabled: PropTypes.bool.isRequired,
    dialogType: PropTypes.string.isRequired,
    handleCloseDetails: PropTypes.func.isRequired,
};
